import React, { createContext, useState, useCallback } from 'react';

export const HomePageContext = createContext();

export function HomePageProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [listSortBy, setListSortBy] = useState('price');
  const [listSortOrder, setListSortOrder] = useState('asc');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [expandedManufacturer, setExpandedManufacturer] = useState(null);

  const resetFilters = useCallback(() => {
    setSearchTerm('');
    setSelectedManufacturer(null);
    setSelectedProductType(null);
    setExpandedManufacturer(null);
  }, []);

  const value = {
    products,
    setProducts,
    manufacturers,
    setManufacturers,
    productTypes,
    setProductTypes,
    loading,
    setLoading,
    error,
    setError,
    viewMode,
    setViewMode,
    listSortBy,
    setListSortBy,
    listSortOrder,
    setListSortOrder,
    searchTerm,
    setSearchTerm,
    selectedManufacturer,
    setSelectedManufacturer,
    selectedProductType,
    setSelectedProductType,
    expandedManufacturer,
    setExpandedManufacturer,
    resetFilters
  };

  return (
    <HomePageContext.Provider value={value}>
      {children}
    </HomePageContext.Provider>
  );
}
